"use client"

import { GoogleAnalytics as GA } from "@next/third-parties/google"
import Script from "next/script"
import { GA_MEASUREMENT_ID, ADS_CONVERSION_ID } from "@/lib/gtag"

export default function GoogleAnalytics() {
  return (
    <>
      <GA gaId={GA_MEASUREMENT_ID} />
      <Script
        id="google-ads-config"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `gtag('config', '${ADS_CONVERSION_ID}');`,
        }}
      />
    </>
  )
}
